.ix{margin:0px;}